import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { WHATSAPP_LINK } from '../data/mock';

export default function WhatsAppFloat() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <a
      href={WHATSAPP_LINK()}
      target="_blank" rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className={`cursor-hover fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 bg-[#C8FF61] hover:bg-[#F5F1E8] text-[#0A0B0E] pl-4 pr-5 py-3.5 rounded-full text-[13px] font-semibold shadow-[0_18px_60px_-15px_rgba(200,255,97,0.7)] transition-all duration-500 ${
        show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6 pointer-events-none'
      }`}
    >
      <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-[#0A0B0E]/15">
        <MessageCircle size={18} />
        <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-[#0A0B0E] animate-ping" />
        <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-[#0A0B0E]" />
      </span>
      Fale no WhatsApp
    </a>
  );
}
